import { PlayArrow, Stop } from '@mui/icons-material';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { Focus } from 'lucide-react';
import { Fragment } from 'react';
import { useIntl } from 'react-intl';
import { MovieReviewSlider } from '~/components/Sliders/MovieReviewSlider';
import StructureLabel from '~/components/Structures/StructureLabel';
import { RoiReadModel } from '~/domain/readmodels/StructureSetReadModel';
import { useAutoScroll } from '~/hooks/useAutoScroll';
import useViewportFocus from '~/hooks/useViewportFocus';

export default function ReviewPlayer({
    roi,
    showLabel = true,
}: {
    roi: RoiReadModel;
    showLabel?: boolean;
}) {
    const intl = useIntl();
    const { setShouldScroll, shouldScroll } = useAutoScroll(roi.roiNumber);
    const handleAutoScroll = () => {
        setShouldScroll(!shouldScroll);
    };
    const { focusOnStructure } = useViewportFocus();

    const handleFocusOnStructure = () => {
        focusOnStructure(roi.roiNumber);
    };

    return (
        <Fragment>
            {showLabel && (
                <Stack
                    spacing={2}
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%"
                >
                    <StructureLabel roi={roi} />

                    <Tooltip title={'Focus'}>
                        <IconButton
                            aria-label={intl.formatMessage({
                                id: 'focusOnStructure',
                            })}
                            size="small"
                            onClick={handleFocusOnStructure}
                        >
                            <Focus size={16} />
                        </IconButton>
                    </Tooltip>
                </Stack>
            )}
            <Stack direction={'row'} alignItems={'center'} gap={1} ml={-0.5}>
                <Tooltip title={shouldScroll ? 'Stop' : 'Play'}>
                    <IconButton
                        aria-label={intl.formatMessage({
                            id: 'autoScrollStructure',
                        })}
                        onClick={handleAutoScroll}
                        size="small"
                        sx={{
                            p: 0,
                            position: 'relative',
                            zIndex: 1,
                        }}
                    >
                        {shouldScroll ? (
                            <Stop fontSize="small" />
                        ) : (
                            <PlayArrow fontSize="small" />
                        )}
                    </IconButton>
                </Tooltip>
                <MovieReviewSlider />
            </Stack>
        </Fragment>
    );
}
